<template>
	<span class="arrow" :class="{active}">
		<span></span>
		<span></span>
	</span>
</template>

<script>
export default {
	props: {
		active: {
			default: false,
		},
	},
	// methods: {
	// 	toggle() {

	// 		this.active = !this.active
	// 	}
	// },
}
</script>

<style lang="scss" scoped>
	.arrow {
		vertical-align: text-bottom;
		width: 1.25rem;
		height: 1.25rem;
		display: inline-block;
		position: relative;
		// margin: 0 .25rem;

		span {
			top: 0.5rem;
			position: absolute;
			width: 0.75rem;
			height: 0.15rem;
			background-color: black;
			// border-radius: .1rem;
			display: inline-block;
			// transition: all 0.5s cubic-bezier(.25,1.7,.35,.8);
			transition: all 0.2s ease-out;

			&:first-of-type {
				// right: 39%;
				left: 0;
				transform: rotate(45deg);
			}

			&:last-of-type {
				// left: 39%;
				right: 0;
				transform: rotate(-45deg);
			}
		}

		&.active {
			span {
				&:first-of-type {
					transform: rotate(-45deg);
				}

				&:last-of-type {
					transform: rotate(45deg);
				}
			}
		}
	}
</style>